import isNil from 'lodash/isNil';
import some from 'lodash/some';
import {UserData} from '../../../../../../security-context.model';
import {isSysAdminOrManager} from '../../../../../../utils/permissions-utils';
import {FieldDisablementReason} from '../configured-fields/field-disablement-reason.model';
import {Phase} from '../../../../../../shared/model/phase.model';
import {Application} from '../../../loan-application.model';
import {CheckValue} from './check-value.model';
import {FieldType} from "../../../../../../shared/model/field.model";

const hasFieldActionOwnerPermission = (permittedRolesIds?: number[], userData?: UserData, application?: Application) => {
  const userRoleIsAllowed = some(permittedRolesIds, role => some(userData?.roleIds, userRole => userRole === role));

  return userRoleIsAllowed;
}

const isUserHasPermission = (permittedRolesIds?: number[], userData?: UserData, application?: Application, fieldType?: FieldType): boolean => {
  if (isNil(userData)) {
    return false;
  }

// Allow SysAdmin/Manager for all checks EXCEPT Credit Bureau Score Check
// Special case: this field should be editable only by field action owner,
// ignoring SysAdmin/Manager global override.
  if (fieldType !== FieldType.CREDIT_BUREAU_CHECK && isSysAdminOrManager(userData)) {
    return true;
  }

  return hasFieldActionOwnerPermission(permittedRolesIds, userData, application);
};

const hasFieldBeenModifiedByUser = (checkValue?: CheckValue<unknown> | undefined): boolean => {
  if (isNil(checkValue?.value)) {
    return false;
  }

  if (isNil(checkValue?.lastModifiedByUserId)) {
    return false;
  }

  return true;
}

export const getDisablementReason =
  (permittedRolesIds?: number[], userData?: UserData, application?: Application, checkValue?: CheckValue<unknown> | undefined, checkName?: string): FieldDisablementReason | undefined => {
    const hasPermission = isUserHasPermission(permittedRolesIds, userData, application, checkValue?.fieldType);
    if (!hasPermission) {
      return FieldDisablementReason.NO_PERMISSIONS_TO_EDIT
    }

   if (hasFieldBeenModifiedByUser(checkValue)) {
     return FieldDisablementReason.VALUE_ALREADY_MODIFIED;
   }

  return undefined;
};

export const hasEditableFields = (config?: Phase | undefined, userData?: UserData, application?: Application) => config?.checkGroups?.some(group => group.checks?.some(check =>
  isUserHasPermission(check.roleIds, userData, application, check?.proofType))) || false;

